import React from "react";

export function PageHeader({ title, sub, children }) {
  return (
    <header className="page-header">
      <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
        <h1 className="page-title">{title}</h1>
        {sub && <p className="page-sub">{sub}</p>}
      </div>
      {children && <div className="page-actions">{children}</div>}
    </header>
  );
}

export function Card({ title, id, desc, children, style, className = "" }) {
  return (
    <section className={`card pad ${className}`} aria-labelledby={id} style={style}>
      {(title || desc) && (
        <div>
          {title && (
            <h2 id={id}>{title}</h2>
          )}
          {desc && <p className="desc">{desc}</p>}
        </div>
      )}
      {children}
    </section>
  );
}

export function Button({ variant, size, icon, children, className = "", ...rest }) {
  const cls = ["btn", variant, size, className].filter(Boolean).join(" ");
  return (
    <button type="button" className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
}

export function Stat({ label, value, suffix, sub, color, compact, valueClass = "num" }) {
  return (
    <div className={`stat ${compact ? "compact" : ""}`}>
      <span className="label">{label}</span>
      <span className={`value ${valueClass}`} style={color ? { color } : undefined}>
        {value}
        {suffix && <small> {suffix}</small>}
      </span>
      {sub && (
        <span className="sub" title={typeof sub === "string" ? sub : undefined}>
          {sub}
        </span>
      )}
    </div>
  );
}

export function Pill({ kind = "neutral", children }) {
  return <span className={`pill ${kind}`}>{children}</span>;
}

export function Tag({ kind = "neutral", children, title }) {
  return (
    <span className={`tag ${kind}`} title={title}>
      {children}
    </span>
  );
}

export function Segmented({ options, value, onChange, label }) {
  return (
    <div role="tablist" aria-label={label} className="segmented">
      {options.map((o) => (
        <button
          key={o.value}
          role="tab"
          type="button"
          aria-selected={value === o.value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function Empty({ title, children }) {
  return (
    <div className="empty">
      {title && <strong>{title}</strong>}
      {children && <span>{children}</span>}
    </div>
  );
}

export function Skeleton({ width = "100%", height = 14, style }) {
  return <span className="skeleton" style={{ display: "inline-block", width, height, ...style }} aria-hidden="true" />;
}

export function Dot({ color }) {
  return <span className="dot" style={{ background: color }} />;
}

export function Pager({ page, pages, onChange, from, to, total, noun = "Rows" }) {
  return (
    <div className="tbl-footer">
      <span>
        {total === 0 ? `No ${noun.toLowerCase()}` : `${noun} ${from}–${to} of ${total}`}
      </span>
      <div className="pager">
        <button type="button" aria-label="Previous page" disabled={page <= 1} onClick={() => onChange(page - 1)}>
          ‹
        </button>
        <button type="button" aria-label="Next page" disabled={page >= pages} onClick={() => onChange(page + 1)}>
          ›
        </button>
      </div>
    </div>
  );
}
